"use client";

import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import { globalTransition } from "../../assets/animate/globalAnimation";

const MissionSection: React.FC = () => {
  const controls = useAnimation();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          controls.start("visible");
        } else {
          controls.start("hidden");
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [controls]);

  const variants = {
    hiddenLeft: { opacity: 0, x: -100 },
    hiddenRight: { opacity: 0, x: 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { ...globalTransition, ease: "easeOut", duration: 2.5 }, // Increased duration
    },
  };

  return (
    <div
      ref={sectionRef}
      className="bg-[linear-gradient(180deg,_#2D3A45_50%,_#ffffff_50%)] lg:pb-24"
    >
      <div className="bg-[#AB052D] text-lg lg:min-h-[70vh] text-white lg:relative overflow-hidden grid grid-cols-1 lg:grid-cols-8 lg:ml-[20%]">
        <motion.div
          initial="hiddenLeft"
          animate={controls}
          variants={variants}
          className="hidden lg:block lg:absolute lg:left-16 lg:top-6 lg:right-20 z-30 p-4 lg:px-10"
        >
          <h4 className="text-2xl">Our Mission</h4>
          <div className="border-b w-full border-b-red-400 my-2"></div>
        </motion.div>

        <motion.div
          initial="hiddenRight"
          animate={controls}
          variants={variants}
          className="lg:col-span-4 z-30 order-1 lg:order-2 relative"
        >
          <motion.div
            style={{
              backgroundImage: "url('/assets/image/mission.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="w-full h-[70vh] lg:hidden flex flex-col justify-start p-6 bg-opacity-50 bg-black"
          >
            <h4 className="text-white text-2xl font-medium">Our Mission</h4>
            <div className="border-b border-b-gray-200 my-2 w-full"></div>
          </motion.div>

          <motion.img
            src="/assets/image/mission.png"
            className="hidden w-full h-full lg:block object-cover"
            alt="Our Mission"
          />
        </motion.div>

        <motion.div
          initial="hiddenLeft"
          animate={controls}
          variants={variants}
          className="lg:col-span-4 text-sm leading-loose lg:leading-[2rem] lg:text-lg lg:pt-40 lg:p-28 lg:py-32 p-10 order-2 lg:order-1"
        >
          At Siskon Ventures Pvt Ltd., our mission is to seamlessly integrate
          hydraulic systems that redefine efficiency and reliability. We strive
          to exceed client expectations by leveraging cutting-edge technology,
          fostering a culture of expertise, and delivering turnkey solutions
          tailored to meet the unique needs of each industry.
        </motion.div>
      </div>
    </div>
  );
};

export default MissionSection;
